import type { BlockedRow, CandidateKind } from './picker-candidates.policy';

export const LEGAL_BLOCK_LABEL = 'Cannot be overridden';

export const KIND_LABELS: Record<CandidateKind, string> = { truck: 'Truck', trailer: 'Trailer', driver: 'Driver' };

/** The one line beside a blocked row: the first reason, with a count when there are more. */
export function blockedSummary({ failedChecks }: Pick<BlockedRow, 'failedChecks'>): string {
  const [first] = failedChecks;
  if (!first) return 'Blocked';
  const reason = first.reason ?? first.code;
  return failedChecks.length === 1 ? reason : `${reason} (+${failedChecks.length - 1} more)`;
}
